import { Icon } from '@chakra-ui/react';

interface Properties {
  width?: number;
  height?: number;
}

const Close = ({ width = 2.25, height = 2.25 }: Properties) => {
  return (
    <Icon viewBox='0 0 9 9' width={width} height={height}>
      <g clipPath='url(#clip0_1559_2370)'>
        <path
          d='M0.692308 9L0 8.30769L3.80769 4.5L0 0.692308L0.692308 0L4.5 3.80769L8.30769 0L9 0.692308L5.19231 4.5L9 8.30769L8.30769 9L4.5 5.19231L0.692308 9Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_1559_2370'>
          <rect width='9' height='9' fill='white' />
        </clipPath>
      </defs>
    </Icon>
  );
};

export default Close;
